const style = {
  group: {
    margin: `15px -15px`
  },
  checkbox: {
    border: `1px solid #666`
  },
  checkbox_check: {
    background: `#666`
  },
  input: {
    border: `1px solid #666`,
    background: `#fff`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/style/ColorBlind/form.js